module.exports = __webpack_public_path__ + "img/finances-bg.94f1b55c.png";